__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__Fcn5Qa__accordion",
  "content": "Accordion-module-scss-module__Fcn5Qa__content",
  "icon": "Accordion-module-scss-module__Fcn5Qa__icon",
  "root": "Accordion-module-scss-module__Fcn5Qa__root",
  "summary": "Accordion-module-scss-module__Fcn5Qa__summary",
  "summaryOpen": "Accordion-module-scss-module__Fcn5Qa__summaryOpen",
  "wrapper": "Accordion-module-scss-module__Fcn5Qa__wrapper",
});
